// akhila 1/12/2022 2692790263 added BasicInfo in workqueue
// akhila 1/12/2022 2692790263 added new payload changes
// kavya9reddy 12/1/2022 2692790263 added validation in basic info
// Sohel 12/04/2022 2692790263 Added alertPopup
// akhila 12/07/2022 2692790263 added default value for createdFor
// akhila 12/08/2022 2692790263 changed labels workqueue to Work Queue
// Sohel 12/13/2022 2692790263 conditionally hide Save Button
// Lalitha 12/23/2022 2692790263 Added reusable Validation in code
// Raghu 12/29/2022 2692790263 Button Spacing Fixes
// kavyareddy 01/05/2023 2692790263 Fixed label issues
// //Sohel 02/13/2023 2692790263 WorkQueue validation Changes
// Ravi 02/20/2023 2692790263 fixed validation issue in code
// Ravi 02/22/2023 2692790263 Added Client Code Field
// Rohini 02/28/2023 2692790263 removed the class name
// suresh peddavoora 03/01/2023 2692790263 new ui changes
// suresh peddavoora 03/03/2023 2692790263 Tables and fields alignments
// suresh peddavoora 03/06/2023 2692790263 New UI changes for textfields
// sohel 03/06/2023 2692790263 Added validation message for existing value
// Raghu 03/09/2023 2692790263 added new new classname for primary account field
// Prakash 11-04-23 2692790263 fixed input filed issue in Work Queue Setup.
// Ravi 04/19/2023 2692790263  modified client code dropDownData data
// Ravi 05/08/2023 2692790263  fixed accept only upper Case in WorkQueue Code
// Phanee 06/02/2023 2692790263 Work Queue Duplicate Render Issue
// Ravi 07/19/2023 2692790263  added fixedlength field in Basic Info
// Ravi 06/24/2023 2692790263  removed type from basicInfo get API
// Ravi 07/24/2023 2692790263  removed upperCase from workQueue Name
// Ravi 07/26/2023 2692790263  removed multiple hypen validation from workQueue Name
import {
  Button,
  FormHelperText,
  MenuItem,
  TextField,
  InputLabel,
  Select,
  FormControl,
} from '@material-ui/core';
import {Formik} from 'formik';
import React, {useEffect, useRef, useState, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import * as Yup from 'yup';
import {ThemeContext} from './../../../themes/ThemeProvider';
import {SuccessSnackbar, ErrorSnackbar} from './../../../components/CustomSnackBar/index';
import PageLoader from './../../../components/PageLoader/index';
import {
  postHeaderInfo,
  resetMessage,
  fetchBasicInfo,
  getAllReportCodeData,
  getAllReportCreatedForData,
  resetReportFieldsData,
  setReduxState,
} from '../../../redux/reducers/ReportMaster';
import {currsorCodeIssue} from '../../../components/UpperCaseCode';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';

const WorkQueueBasicInfo = ({
  activeStep,
  handleBack,
  handleNext,
  workQueue,
  handleDirty,
  roleAccess,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {
    isLoading,
    successMsg,
    errorMsg,
    addHeaderStatus,
    reportMasterData,
    basicInfoData,
    reportCodeData,
    reportCode,
    reportCreatedForData,
  } = useSelector(({reportMaster}) => reportMaster);
  const [codePopover, setCodePopover] = useState(false);
  const [reportCodesData, setReportCodesData] = useState();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);

  const saveRef = useRef();
  const codeRef = useRef();
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const checkReportCodeExist = (value) => {
    if (reportCodeData && reportCodeData?.length > 0 && value) {
      const ar = [];
      reportCodeData?.forEach((i) => {
        if (
          i?.reportCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y' &&
          basicInfoData?.reportCode?.toLowerCase()?.trim() !== value?.toLowerCase()?.trim()
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkReportCodeAlreadyExist = (value) => {
    if (reportCodeData && reportCodeData?.length > 0 && value) {
      const ar = [];
      reportCodeData?.forEach((i) => {
        if (
          i?.reportCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N' &&
          basicInfoData?.reportCode?.toLowerCase()?.trim() !== value?.toLowerCase()?.trim()
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const options = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const fixedLengthOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const dateStampOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const getObject = (option, options) => {
    let obj = {};
    options &&
      options?.map((ele) => {
        if (option === ele.value || option === ele.key || option === ele.userName) {
          obj = ele;
        }
      });
    return obj;
  };

  const getReportCodesData = () => {
    if (reportCodeData && reportCodeData?.length > 0) {
      return reportCodeData?.filter(
        (i) => String(i?.reportCode)?.startsWith(reportCodesData) && i?.isActive === 'Y',
      );
    } else {
      return [];
    }
  };

  const validationSchema = Yup.object().shape({
    reportcode: Yup.string()
      .required('Work Queue Name is required')
      .test('reportCode', 'Work Queue Name already in use', (value) => !checkReportCodeExist(value))
      .test(
        'reportCode',
        'Work Queue Name has already been used in the past',
        (value) => !checkReportCodeAlreadyExist(value),
      )
      .max(25, 'Work Queue Name cannot exceed 25 characters'),
    reportDescription: Yup.string()
      .required('Work Queue Description is required')
      .max(100, 'Work Queue Description cannot exceed 100 characters'),
    seedOnly: Yup.string().required('Primary Account is required').nullable(),
    // fixedLength: Yup.object().nullable().required("Fixed Length is required"),
    dateStamp: Yup.object().nullable().required('Date Stamp require is required'),
  });
  const getClientCodes = (user, clientCodeData) => {
    return clientCodeData?.filter((i) => user?.includes(i?.clientNumber));
  };
  const user = JSON.parse(sessionStorage.getItem('userDetails'));
  const initialState = {
    reportcode: basicInfoData?.reportCode ? basicInfoData?.reportCode : '',
    seedOnly: basicInfoData?.seedOnly ? basicInfoData?.seedOnly : 'N',
    reportDescription: basicInfoData?.reportDescription ? basicInfoData?.reportDescription : '',
    createdFor: basicInfoData?.createdFor ?
      getObject(basicInfoData?.createdFor, reportCreatedForData) :
      {userName: user?.userName},
    user:
      basicInfoData?.clientCode?.length > 0 ?
        getClientCodes(basicInfoData?.clientCode, clientCodeDropdownData) :
        [],
    fixedLength: basicInfoData?.fixedLength ?
      getObject(basicInfoData?.fixedLength, fixedLengthOptions) :
      {key: 'N', value: 'No'},
    dateStamp: basicInfoData?.requireDateStamping ?
      getObject(basicInfoData?.requireDateStamping, dateStampOptions) :
      {key: 'N', value: 'No'},
  };

  const handleSubmit = (values) => {
    const clientCode = values?.user?.length > 0 ? values?.user?.map((el) => el?.clientNumber) : [];
    if (values) {
      dispatch(submissionStart());
      const data = {
        createdFor: values?.createdFor?.userName ? values?.createdFor?.userName : '',
        recordsToInclude: '',
        reportCode: values?.reportcode ? values?.reportcode : '',
        reportDescription: values?.reportDescription ? values?.reportDescription : '',
        reportId: reportMasterData?.reportId ?
          reportMasterData?.reportId :
          basicInfoData?.reportId ?
            basicInfoData?.reportId :
            0,
        seedOnly: values?.seedOnly ? values?.seedOnly : '',
        lastStep: saveRef.current ? 0 : 1,
        reportType: 'WQ',
        title: '',
        clientCode: clientCode,
        fixedLength: values?.fixedLength?.key ? values?.fixedLength?.key : 'N',
        requireDateStamping: values?.dateStamp?.key ? values?.dateStamp?.key : 'N',
      };
      dispatch(postHeaderInfo(data));
      // setReportCodeData(values?.reportcode);
      dispatch(setReduxState({property: 'initialSave', value: data?.reportId ? false : true}));
    }
  };

  useEffect(() => {
    if (addHeaderStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
        !saveRef.current && handleNext();
      }, 1000);
    }
  }, [addHeaderStatus]);

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 500);
    }
  }, [errorMsg, successMsg]);

  useEffect(() => {
    if (reportCode) {
      dispatch(fetchBasicInfo(reportCode));
      dispatch(resetReportFieldsData());
    }
  }, [reportCode]);

  useEffect(() => {
    dispatch(getAllReportCodeData());
    dispatch(getAllReportCreatedForData());
  }, []);

  window.onclick = function() {
    setCodePopover(false);
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialState}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row global-field-textfields new-standard-textfields">
                <div
                  className={`col-sm-6 col-md-4 col-lg-4  col-xl-4 ${
                    errors?.reportcode?.length > 30 ? 'form-group-lg' : 'form-group'
                  }`}
                >
                  <TextField
                    placeholder="Enter Work Queue Name"
                    className={` ${classes.labelName}`}
                    margin="dense"
                    name="reportcode"
                    variant="outlined"
                    value={values?.reportcode}
                    label="Work Queue Name"
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    required
                    inputRef={codeRef}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      const value = currsorCodeIssue(codeRef);
                      setFieldValue('reportcode', value);
                      if (e.target.value) {
                        setCodePopover(true);
                        setReportCodesData(e.target.value);
                      } else if (e.target.value === '') {
                        setCodePopover(false);
                      }
                    }}
                    touched={touched.reportcode}
                    error={Boolean(errors.reportcode && touched.reportcode)}
                    fullWidth
                  />
                  <FormHelperText style={{color: 'red'}} variant="outlined">
                    {touched.reportcode && errors.reportcode}
                  </FormHelperText>
                  <div className="windowcode-popover Add-trigger-group-popover">
                    {codePopover &&
                      getReportCodesData()?.map((data, i) => (
                        <MenuItem key={i}>{data?.reportCode}</MenuItem>
                      ))}
                  </div>
                </div>
                <div className="col-sm-6 col-md-8 col-lg-8 col-xl-8 form-group">
                  <TextField
                    // className={` ${classes.labelName} ${classes.inputLabel}`}
                    placeholder="Enter Work Queue Description"
                    className={` ${classes.labelName}`}
                    margin="dense"
                    name="reportDescription"
                    value={values.reportDescription}
                    variant="outlined"
                    label="Work Queue Description"
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    touched={touched.reportDescription}
                    required
                    error={Boolean(errors.reportDescription && touched.reportDescription)}
                    fullWidth
                  />
                  <FormHelperText style={{color: 'red'}} variant="outlined">
                    {touched.reportDescription && errors.reportDescription}
                  </FormHelperText>
                </div>
                <div
                  className={`form-group col-sm-3 col-md-4 col-lg-4 col-xl-4 ${classes.selectField}`}
                >
                  <FormControl margin="dense" variant="outlined" fullWidth className="form-group">
                    <InputLabel id="demo-simple-select-label">Primary Accounts Only</InputLabel>
                    <Select
                      fullWidth
                      name="seedOnly"
                      className={` ${classes.labelName}`}
                      labelId="demo-simple-select-label"
                      label="Primary Accounts Only"
                      value={values?.seedOnly ?? 'N'}
                      onChange={handleChange}
                      placeholder="Select seedOnly"
                      onBlur={handleBlur}
                      touched={touched?.seedOnly}
                      error={Boolean(touched?.seedOnly && errors?.seedOnly)}
                    >
                      {options.map((option) => {
                        return (
                          <MenuItem
                            className={` ${classes.labelName}`}
                            value={option.key}
                            key={option.key}
                          >
                            {option.value}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormHelperText>
                    {touched?.seedOnly && errors.seedOnly && errors.seedOnly}
                  </FormHelperText>
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center new-standard-textfields disabled-button">
                <Button
                  variant="outlined"
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                  disabled={activeStep === 0}
                  onClick={handleBack}
                >
                  Back
                </Button>
                {/* {isDraftReport === "N" && ( */}
                <Button
                  variant="outlined"
                  type="submit"
                  className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  disabled={roleAccess || enabledSubmission}
                  onClick={() => {
                    saveRef.current = true;
                    handleDirty(false, 'fixed');
                  }}
                >
                  Save
                </Button>
                {/* )} */}
                <Button
                  variant="outlined"
                  type="submit"
                  className={`search-btn ml-1 ${classes.buttonRoot}`}
                  disabled={roleAccess || enabledSubmission}
                  onClick={() => {
                    saveRef.current = false;
                  }}
                >
                  Save & Next
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default WorkQueueBasicInfo;
